import { getUpdateCartFunction } from "@faire/retailer-visitor-shared/features/ProductAdd/utils";
import { useCartItems } from "@faire/retailer-visitor-shared/hooks/cart/useCartItems";
import { useCartUpdate } from "@faire/retailer-visitor-shared/hooks/cart/useCartUpdate";
/**
 * Satisfies the IProductAddOptions interface by combining
 * useCartItems and useCartUpdate.
 */ export var useCartProductAddOptions = function(updateItemOverride) {
    var _useCartItems = useCartItems(), cartItems = _useCartItems.cartItems, getItemByToken = _useCartItems.getItemByToken, getProductTileQuantityInCart = _useCartItems.getProductTileQuantityInCart, getItemByProductOptionTokenAndCustomizations = _useCartItems.getItemByProductOptionTokenAndCustomizations;
    var updateCartItemsWithUpdateHandler = useCartUpdate().updateCartItemsWithUpdateHandler;
    return {
        addedItems: cartItems,
        getAddedItemByToken: getItemByToken,
        getAddedItemQuantityByToken: getProductTileQuantityInCart,
        getAddedItemByProductOptionTokenAndCustomizations: getItemByProductOptionTokenAndCustomizations,
        addOrUpdateItems: function() {},
        addOrUpdateItemsV2: getUpdateCartFunction(updateItemOverride !== null && updateItemOverride !== void 0 ? updateItemOverride : updateCartItemsWithUpdateHandler, true),
        addOrUpdateItemsV2withSyncInventoryFetch: getUpdateCartFunction(updateItemOverride !== null && updateItemOverride !== void 0 ? updateItemOverride : updateCartItemsWithUpdateHandler, false)
    };
};
